import React from 'react';
const Mutuo = () => {
    return (
        <>            
            <table cellpadding="3" cellspacing="0">
                <tbody>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="2">Elenco documenti Notaio per l'atto di Mutuo per&nbsp;persone fisiche</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Carta d’identità o patente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Tesserino del codice fiscale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato di stato libero o di vedovanza</td>
                        <td valign="top">Per celibi, nubili, vedovi, divorziati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Estratto per riassunto dell’atto di matrimonio</td>
                        <td valign="top">Per coniugati, anche se separati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Sentenza/decreto di separazione o di divorzio</td>
                        <td valign="top">Per separati e divorziati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia dell’atto di separazione dei beni</td>
                        <td valign="top">Per coniugati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Autorizzazione giudiziale</td>
                        <td valign="top">Per rappresentanza di incapaci</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Permesso di soggiorno</td>
                        <td valign="top">Per extracomunitari</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="3">Elenco documenti Notaio per l'atto di Mutuo per enti e società</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">documento d’identità del legale rappresentante</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">certificato camerale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">statuto vigente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">libro verbali con delibera firmata</td>
                        <td valign="top">Per enti con consiglio di amministrazione</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2 id="4">Elenco documenti Notaio per l'atto di Mutuo inerenti il bene immobile ipotecato</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Rogito o sentenza</td>
                        <td valign="top">Titolo di acquisto</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">- Dichiarazione di successione
                        - Accettazione di eredità</td>
                        <td valign="top">Se l’acquisto è avvenuto per
                        successione</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato catastale e planimetria con confini</td>
                        <td valign="top">Se si tratta di unità immobiliare</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato catastale e planimetria con confini</td>
                        <td valign="top">Se si tratta di terreno</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">
                        <p>- Prova di estinzione del debito o conteggi per estinzione contestuale
                        - Lettera di assenso della Banca</p>
                        </td>
                        <td valign="top">Se c’è ipoteca precedente</td>
                    </tr>
                </tbody>
            </table>
        </>
        );
    }

export default Mutuo;